module.exports = __webpack_public_path__ + "images/thin-logo-a0529e74363eb680976a4d4acebc367f.png";